import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { configsForProcess, processKeysForSection } from './command-config-processes';

@Component({
  selector: 'app-command-config-links',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './command-config-links.html',
  styleUrl: './command-config-links.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommandConfigLinksComponent {
  readonly sectionName = input<string | null>(null);
  readonly processKey = input<string | null>(null);

  readonly processKeys = computed(() => processKeysForSection(this.sectionName()));
  readonly configs = computed(() => configsForProcess(this.processKey()));
}
